module.exports = __webpack_public_path__ + "media/components/country-flag/static/pg-7de262efba52d6557471b370998ecdbc.svg";